// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import {connect} from 'react-redux';
import {bindActionCreators, type Dispatch} from 'redux';

import {getPost, makeGetPostsForThread} from 'mattermost-redux/selectors/entities/posts';
import {removePost, getPostThread} from 'mattermost-redux/actions/posts';
import {type GenericAction} from 'mattermost-redux/types/actions';
import {type Post} from 'mattermost-redux/types/posts';

import {getSelectedChannel, getSelectedPost} from 'selectors/rhs';
import {selectPostCard} from 'actions/views/rhs';
import {type GlobalState} from 'types/store';

import {getChannel} from 'mattermost-redux/selectors/entities/channels';

import RhsThread from './rhs_thread';

type OwnProps = {
    rootPostId?: string;
};

function makeMapStateToProps() {
    const getPostsForThread = makeGetPostsForThread();

    return function mapStateToProps(state: GlobalState, ownProps: OwnProps) {
        const selected = ownProps.rootPostId ? getPost(state, ownProps.rootPostId) : getSelectedPost(state);
        const channel = ownProps.rootPostId ? getChannel(state, selected!.channel_id) : getSelectedChannel(state);

        let posts: Post[] = [];
        if (selected) {
            posts = getPostsForThread(state, selected.id);
        }

        return {
            selected,
            channel,
            posts,
        };
    };
}

function mapDispatchToProps(dispatch: Dispatch<GenericAction>) {
    return {
        actions: bindActionCreators({
            removePost,
            selectPostCard,
            getPostThread,
        }, dispatch),
    };
}

export default connect(makeMapStateToProps, mapDispatchToProps)(RhsThread);
